<template>
  <v-dialog v-model="dialog" max-width="520">
    <v-card :class="cardClass">
      <v-card-title :class="titleClass">
        {{ title }}

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :class="confirmButtonClass" :color="confirmButtonColor" variant="elevated" :elevation="confirmButtonElevation" :loading="loading" @click="$emit('confirm')">
          {{ confirmLabel }}
        </v-btn>
        <v-btn variant="text" :disabled="loading" @click="dialog = false">
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WebhookConfirmDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'confirm'],
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    titleClass() {
      const colorClass = this.danger ? 'dialog-title' : `bg-${this.color}`;
      return `${colorClass} d-flex justify-space-between`;
    },
    cardClass() {
      return this.danger ? 'vb-dialog vb-dialog-danger' : '';
    },
    confirmButtonClass() {
      return this.danger ? 'btnOk' : '';
    },
    confirmButtonColor() {
      return this.danger ? undefined : this.color;
    },
    confirmButtonElevation() {
      return this.danger ? 0 : undefined;
    },
  },
}
</script>
